import * as z from "zod/v4";

export const getCurrentUserDepartment = {
  name: "getCurrentUserDepartment" as const,
  input: z.object({}),
  output: z.object({ department: z.string().nullable() }),
};

export type GetCurrentUserDepartmentInput = z.infer<
  typeof getCurrentUserDepartment.input
>;
export type GetCurrentUserDepartmentOutput = z.infer<
  typeof getCurrentUserDepartment.output
>;
